import { createSelector } from 'reselect'

const SavingStatusSelector = state => state.myLibrary

const myLibraryPendingLessonsSelector = createSelector(
	[SavingStatusSelector],
	myLibrary => {
		const pending= myLibrary.pending_lessons
		return {
			pending_lessons: pending,
		}
	}
)

export default myLibraryPendingLessonsSelector
